import React from 'react'
import PatientsWrapper from './blueprint/wrapper'

export default function Patients(baseProps) {
  return <PatientsWrapper {...baseProps} />
}
